import pickBy from 'lodash/pickBy'
import type { AriaAttributes, PropsWithChildren } from 'react'

export function ariaAttributes<T>(props: PropsWithChildren<T>): AriaAttributes {
    return pickBy(props, (_, key) => key.startsWith('aria-'))
}
